const SORT_ORDER = {
  ASCENDING: -1,
  DESCENDING: 1,
  EQUAL: 0,
};

export function customSort(a: any, b: any): number {
  const aDate = new Date(a?.dtMovimento);
  const bDate = new Date(b?.dtMovimento);

  if (bDate > aDate) {
    return SORT_ORDER.DESCENDING;
  } else if (bDate < aDate) {
    return SORT_ORDER.ASCENDING;
  } else {
    if (b.indice > a.indice) {
      return SORT_ORDER.DESCENDING;
    } else if (b.indice < a.indice) {
      return SORT_ORDER.ASCENDING;
    } else {
      return SORT_ORDER.EQUAL;
    }
  }
}
